import { type License } from "@clipboard-health/contract-worker-app-bff";
import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

import { shouldShowRenewLicenseInstructions } from "./utils";

interface UseShowRenewLicenseInstructionsProps {
  licenseAttributes: Pick<License["attributes"], "status" | "qualification" | "expiresAt">;
}

export function useShowRenewLicenseInstructions(props: UseShowRenewLicenseInstructionsProps) {
  const { licenseAttributes } = props;

  const showRenewLicenseInstructionsFlag = useCbhFlag(
    CbhFeatureFlag.SHOW_RENEW_LICENSE_INSTRUCTIONS,
    {
      defaultValue: {
        enabled: false,
      },
    }
  );

  return (
    Boolean(showRenewLicenseInstructionsFlag?.enabled) &&
    shouldShowRenewLicenseInstructions(licenseAttributes)
  );
}
